import {
    CHANGE_ACTIVITY_REASSIGN_REQUEST,
    GET_REASSIGN_ACTIVITY_REQUEST
} from './actionConstants';

export const postActivityReassigne = (payload) => ({
    type: CHANGE_ACTIVITY_REASSIGN_REQUEST,
    payload
});

export const getActivityReassignRequest = (payload) => ({
    type: GET_REASSIGN_ACTIVITY_REQUEST,
    payload
});
